import { render } from "./TeachersListView.vue?vue&type=template&id=c4418332&scoped=true"
import script from "./TeachersListView.vue?vue&type=script&lang=js"
export * from "./TeachersListView.vue?vue&type=script&lang=js"

import "./TeachersListView.vue?vue&type=style&index=0&id=c4418332&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4418332"]])

export default __exports__